// SAM mutates proposals and estimates server-side (discount, line edits...) and then opens the
// proposal view; those writes bypass our RTK mutations, so both caches must be invalidated here or
// the mounted queries keep showing stale numbers (QA #32).
import { estimatesApi } from '@/redux/internal-services/estimatesApi';
import { proposalsApi } from '@/redux/internal-services/proposalsApi';

export function invalidateProposalView(dispatch: (action: unknown) => unknown, engagementId: string): void {
  dispatch(proposalsApi.util.invalidateTags([{ type: 'Proposal' as const, id: engagementId }]));
  dispatch(estimatesApi.util.invalidateTags(['EstimateList', 'Estimate']));
}
